module.exports = __webpack_public_path__ + "img/kf-girl.dd7b3a33.svg";